import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Icon } from "@iconify/react";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../../api/api";
import "./CartDrawer.css";

const CartDrawer = () => {
  const { isCartOpen, toggleCart, cart, cartTotal, updateQuantity, removeFromCart, cartCount } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    toggleCart();
    navigate("/payment");
  };

  return (
    <AnimatePresence>
      {isCartOpen && (
        <>
          <motion.div 
            className="cart-drawer-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={toggleCart}
          />
          <motion.div 
            className="cart-drawer"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", bounce: 0, duration: 0.4 }}
          >
            <div className="cart-header">
              <h2>Your Cart 🛒 <span style={{fontSize:'14px', color:'var(--text-muted)'}}>({cartCount} items)</span></h2>
              <button className="cart-close-btn" onClick={toggleCart}>
                <Icon icon="mdi:close" />
              </button>
            </div>

            <div className="cart-items">
              {cart.length === 0 ? (
                <div className="empty-cart">
                  <Icon icon="mdi:cart-remove" className="empty-cart-icon" />
                  <h3>Hungry?</h3>
                  <p>Add some delicious food to your cart!</p>
                  <button className="btn-primary mt-4" onClick={() => { toggleCart(); navigate("/menu"); }}>
                    Browse Menu
                  </button>
                </div>
              ) : (
                <AnimatePresence initial={false}>
                  {cart.map(item => (
                    <motion.div 
                      key={item.food_id || item.id}
                      className="cart-item"
                      layout
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0, paddingBottom: 0, marginBottom: 0, border: 'none' }}
                      transition={{ opacity: { duration: 0.2 }, layout: { duration: 0.3 } }}
                    >
                      <img src={`${IMAGE_URL}${item.image}`} alt={item.name} className="cart-item-img" />
                      <div className="cart-item-info">
                        <div>
                          <p className="cart-item-name">{item.name}</p>
                          <p className="cart-item-price">₹{Number(item.price).toFixed(2)}</p>
                        </div>
                        <div className="cart-item-actions">
                          <div className="qty-controls">
                            <button className="qty-btn" onClick={() => updateQuantity(item.food_id || item.id, parseInt(item.quantity) - 1)}>
                              <Icon icon="mdi:minus" />
                            </button>
                            <span className="qty-value">{item.quantity}</span>
                            <button className="qty-btn" onClick={() => updateQuantity(item.food_id || item.id, parseInt(item.quantity) + 1)}>
                              <Icon icon="mdi:plus" />
                            </button>
                          </div>
                          <button className="remove-btn" onClick={() => removeFromCart(item.food_id || item.id)}>
                            <Icon icon="mdi:trash-can-outline" />
                          </button>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </AnimatePresence>
              )}
            </div>

            {cart.length > 0 && (
              <div className="cart-footer">
                <div className="cart-summary-row">
                  <span>Subtotal</span>
                  <span>₹{cartTotal.toFixed(2)}</span>
                </div>
                <div className="cart-summary-row">
                  <span>Delivery Fee</span>
                  <span style={{color: 'var(--success)'}}>Free</span>
                </div>
                <div className="cart-summary-row total">
                  <span>Total</span>
                  <span>₹{cartTotal.toFixed(2)}</span>
                </div>
                <button className="btn-primary btn-checkout" onClick={handleCheckout}>
                  Proceed to Checkout
                </button>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;
